import React from 'react';
import { Link } from 'react-router-dom';
import strings from '../Language';
import Bitcoin from '../../assets/images/icons/bitcoin.svg';
import './botcard.scss';

const num = (v) => {
    const n = Number.parseFloat(v);
    return Number.isFinite(n) ? n : null;
};
const signed = (n, digits) => (n > 0 ? '+' : '') + n.toFixed(digits);

/**
 * Glass bot card (Aurora) shared by the Home and Quantitative bot lists.
 * Maths is unchanged from the old per-list markup:
 *   return %  = (livePrice − average_) × 100 / average_
 *   floating  = total_usdt_cost × livePrice − total_usdt_cost × average_
 * Props: to, item, livePrice, ready (live prices have arrived)
 */
const BotCard = ({ to, item, livePrice, ready }) => {
    const price = num(livePrice);
    const avg = num(item.average_);
    const cost = num(item.total_usdt_cost);
    const canCalc = item.is_calculate && ready && price !== null && avg;

    const pct = canCalc ? ((price - avg) * 100) / avg : 0;
    const floating = canCalc && cost !== null ? cost * price - cost * avg : 0;
    const qty = num(item.total_coin_qty) || 0;
    const change = item.liveData ? num(item.liveData.priceChangePercent) : null;

    const name = (item.pair && item.pair.name) ? item.pair.name : '';
    const icon = (item.pair && item.pair.icon_url) ? item.pair.icon_url : Bitcoin;
    const up = pct >= 0;

    return (
        <Link to={to} className="bot-card">
            <div className="bot-card-top">
                <img className="bot-card-avatar" src={icon} alt="" width={40} height={40} />
                <div className="bot-card-id">
                    <div className="bot-card-name">{name}</div>
                    <div className="bot-card-meta">
                        {item.type ? strings.cycle : strings.one_shot}
                        {ready && price !== null ? ' · ' + price.toFixed(5) : ''}
                    </div>
                </div>
                <span className={'bot-card-pill ' + (up ? 'up' : 'down')}>{signed(pct, 2)}%</span>
            </div>
            <div className="bot-card-stats">
                <div>
                    <span className="bot-card-k">{strings.quantity}</span>
                    <span className="bot-card-v">{qty.toFixed(5)}</span>
                </div>
                <div>
                    <span className="bot-card-k">{strings.floating_profit}</span>
                    <span className={'bot-card-v ' + (floating > 0 ? 'up' : floating < 0 ? 'down' : '')}>{signed(floating, 5)}</span>
                </div>
                <div>
                    <span className="bot-card-k">{strings.increase}</span>
                    <span className={'bot-card-v ' + (change > 0 ? 'up' : change < 0 ? 'down' : '')}>{change !== null ? signed(change, 2) : '0.00'}%</span>
                </div>
            </div>
        </Link>
    );
};

export default BotCard;
